/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

const getAttributeType = (key, schema) => {
    const attr_schema = schema?.attributes?.find((item) => {
        return item.key === key;
    });
    const type = attr_schema?.type ?? "text";
    return type;
};

export const transformEntityToAttrs = (entity, schema) => {
    if (!entity) {
        return null;
    }
    if (!schema) {
        return null;
    }
    const _entity = { ...entity };
    delete _entity?.guid;
    delete _entity?.key;
    delete _entity?.title;
    delete _entity?.type;
    delete _entity?.version;
    delete _entity?.created_by;
    delete _entity?.created_at;
    delete _entity?.updated_by;
    delete _entity?.updated_at;
    const attributes = Object.entries(_entity);
    const attrs = [];
    attributes.map(([key, value]) => {
        const type = getAttributeType(key, schema);
        attrs.push({ key, value, type });
    });
    return attrs;
};
